var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_vm._l((_vm.sports),function(sport){return _c('v-card',{key:sport.id + 'sport',staticClass:"my-5 mx-5",on:{"click":function($event){return _vm.$router.push(`/tiimi-admin/sports/${sport.id}/tags`)}}},[_c('v-card-title',[_vm._v(" "+_vm._s(sport.sport_name)+" ")])],1)}),_c('v-card',{attrs:{"flat":""}},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }